import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-screen w-full flex flex-col relative" }
const _hoisted_2 = {
  key: 0,
  id: "sign-out",
  class: "absolute right-0 top-0 p-8 z-10"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-grow flex flex-col relative"
}
const _hoisted_4 = { class: "w-fit px-8 flex flex-grow md:w-2/3 md:min-w-[700px] md:px-16 md:mx-13 min-h-[50vh]" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "w-full progress-bar-container" }
const _hoisted_7 = { class: "md:w-2/3" }

import FlowForm from "@/extends/FlowForm.vue";
import { inject, onMounted, ref} from "vue";
import Footer from './Footer.vue'
import ProgressBar from './components/ProgressBar.vue'
import Form, { SubmitStatus } from "@/modules/Form/Form";
import QuestionModel from "vue-flow-form/src/models/QuestionModel";
import SubmitPreviewScreen from './components/SubmitPreviewScreen.vue'
import SubmitingScreen from './components/SubmitingScreen.vue'
import SubmitFailedScreen from './components/SubmitFailedScreen.vue'
import SubmitSuccess from './components/SubmitSuccess.vue'
import SignoutButton from './components/SignoutButton.vue'
import { User } from "firebase/auth";
import Auth from "@/modules/Auth/Auth";
import DBCollections from "@/modules/Auth/DBCollections";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormView',
  props: {
  id: {
    type: String,
    required: true
  },
},
  emits: ['is-page-loaded'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit;

const auth = inject('auth') as Auth;
const db = inject('dbcollection') as DBCollections;

const user = ref<User|null>();

var loading = ref(true);

const form = ref<Form>(new Form(props.id,auth, db))

function onShowQuestion(question: QuestionModel) {
  form.value.setCurrentQuestionTo(question)
}

function onAnswer(questionAnswered: QuestionModel) {

}

async function OnSubmit(questionList: QuestionModel[]) {
  form.value.submitForm(questionList);
}
emit('is-page-loaded', false);
// only on client side
onMounted(() => {

  auth.GetCurrentUser().then((u : User | null) => {
    user.value = u;
  });
  
  form.value.Build()
    .then(() => {
      loading.value = false;
      
      emit('is-page-loaded', true);
    })
    .catch(e => {
      console.error(e)
      alert(e.message)
    });
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SignoutButton)
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FlowForm, {
              questions: form.value.flowFormQuestions,
              language: form.value.language,
              extraTokens: form.value.extraTokens,
              onAnswer: onAnswer,
              onOnShowQuestion: onShowQuestion,
              onSubmit: OnSubmit,
              onCompleted: _cache[0] || (_cache[0] = ($event: any) => (form.value.onCompleted()))
            }, {
              complete: _withCtx(({submit , isMobile,answeredQuestions}) => [
                (form.value.submitStatus == _unref(SubmitStatus).WAITING_FOR_USER)
                  ? (_openBlock(), _createBlock(SubmitPreviewScreen, {
                      key: 0,
                      "answered-questions": answeredQuestions,
                      "is-mobile": isMobile,
                      submit: submit
                    }, null, 8, ["answered-questions", "is-mobile", "submit"]))
                  : (form.value.submitStatus == _unref(SubmitStatus).PENDING)
                    ? (_openBlock(), _createBlock(SubmitingScreen, { key: 1 }))
                    : (form.value.submitStatus == _unref(SubmitStatus).FAILURE)
                      ? (_openBlock(), _createBlock(SubmitFailedScreen, {
                          key: 2,
                          "is-mobile": isMobile,
                          submit: submit
                        }, null, 8, ["is-mobile", "submit"]))
                      : (form.value.submitStatus == _unref(SubmitStatus).SUCCESS)
                        ? (_openBlock(), _createBlock(SubmitSuccess, { key: 3 }))
                        : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["questions", "language", "extraTokens"])
          ]),
          _createElementVNode("div", {
            id: "bg-illustration z-0",
            class: _normalizeClass(["absolute right-8 bottom-24 w-[150px] md:right-24 md:w-[30vh] md:min-w-[100px] md:max-h-[300px]", {
          'hidden md:block md:opacity-20 md:w-[20vh]': form.value.currentQuestion.type !== 'sectionbreak'
        }])
          }, [
            _createElementVNode("img", {
              src: form.value.CurrentSectionImageURL,
              class: "w-full",
              alt: ""
            }, null, 8, _hoisted_5)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(ProgressBar, {
                _sections: form.value.sections,
                currentQuestionIndex: form.value.currentQuestionIndex,
                submitStatus: form.value.submitStatus
              }, null, 8, ["_sections", "currentQuestionIndex", "submitStatus"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ]))
}
}

})